export default "__VITE_ASSET__7a7a1f04__"